import {
  ACTIVATING_FIREFLIES_REQUEST, ACTIVATING_FIREFLIES_SUCCEDDED, ACTIVATING_FIREFLIES_FAILED,
  UPDATING_FIREFLIES_RECORDING_TOGGLE_REQUEST, UPDATING_FIREFLIES_RECORDING_TOGGLE_SUCCEEDED, UPDATING_FIREFLIES_RECORDING_TOGGLE_FAILED,
} from '../actionTypes';

import { activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const FIREFLIES_BASE_URL = `${apiUrl}/api/2.0/integrations/fireflies`;
const INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/integrations`;

export function activateAccount(configuration) {
  return function (dispatch) {
    dispatch(activatingAccount());

    return axios({
      method: 'POST',
      url: FIREFLIES_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(activatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
      return response.data;
    })
    .catch(error =>
      dispatch(activatingAccountFailed(error.errors))
    )
  }
}

function activatingAccount() {
  return {
    type: ACTIVATING_FIREFLIES_REQUEST,
    payload: {}
  }
}

function activatingAccountSuccedded(json) {
  return {
    type: ACTIVATING_FIREFLIES_SUCCEDDED,
    payload: json
  }
}

function activatingAccountFailed(error) {
  return {
    type: ACTIVATING_FIREFLIES_FAILED,
    payload: error
  }
}

export function updateFireFliesRecordingToggle(enabled) {
  return function (dispatch) {
    dispatch(updatingFireFliesRecordingToggle());

    const url = buildUrl(INTEGRATION_BASE_URL, {
      path: `/fireflies/recording-access`,
    });

    return axios({
      method: "PUT",
      url: url,
      data: enabled
    })
      .then((response) => {
        dispatch(updatingFireFliesRecordingToggleSucceeded(response));
      })
      .catch((error) => {
        dispatch(updatingFireFliesRecordingToggleFailed(error));
      });
  };
}

function updatingFireFliesRecordingToggle() {
  return { type: UPDATING_FIREFLIES_RECORDING_TOGGLE_REQUEST };
}

function updatingFireFliesRecordingToggleSucceeded(response) {
  return {
    type: UPDATING_FIREFLIES_RECORDING_TOGGLE_SUCCEEDED,
    payload: response,
  };
}

function updatingFireFliesRecordingToggleFailed(error) {
  return {
    type: UPDATING_FIREFLIES_RECORDING_TOGGLE_FAILED,
    payload: error,
  };
}